import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared';
import { FooterComponent } from './footer.component';

/**
 * `FooterModule`
 *
 * Embedding <tw-footer> component to the app component
 */
@NgModule({
    imports: [SharedModule],
    declarations: [FooterComponent],
    exports: [FooterComponent]
})
export class FooterModule {
}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.module.ts